import { ViewRequisition } from '../view-requisition/view-requisition.component';
import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { SocialmediaDialogComponent } from '../socialmedia-dialog/socialmedia-dialog.component';
import { ConfirmDeleteDialogComponent } from '../confirm-delete-dialog/confirm-delete-dialog.component';
import { PromoteJobsOfferDialogComponent } from '../promote-jobs-offer-dialog/promote-jobs-offer-dialog.component';
import { SendMessageComponent } from '../send-message/send-message.component';
import { Router, ActivatedRoute } from '@angular/router';
import { JobOffersService } from '../../services/job-offers.service';
import { JobsOffer } from '../../models/jobs-offer';
import { VenueService } from '../../services/venue.service';
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';
import { InviteComponent } from '../invite/invite.component';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { PaymentDialogComponent } from "../payment-dialog/payment-dialog.component";
import { EditOfferVacancyDialogComponent } from '../edit-offer-vacancy-dialog/edit-offer-vacancy-dialog.component';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-list-requisition',
  templateUrl: './list-requisition.component.html',
  styleUrls: ['./list-requisition.component.css']
})
export class ListRequisitionComponent implements OnInit {

  errorMessage: string;
  viewActive: boolean = false;
  selectedOption: string;
  venues: Observable<any[]>;

  venue_id:string;
  offer_id:string;

  jobs: Observable<JobsOffer[]>;
  jobs2: Observable<JobsOffer[]>;
  loading: boolean;
  loading2: boolean;
  max: number = 5;
  page: number = 1;
  total: number = 0;
  question: string;
  public questionFormGroup: FormGroup;

  private landing = `${ environment.landing }`;

  constructor(
      private _router: Router,
      public dialog: MdDialog,
      private jobService: JobOffersService,
      private venueService: VenueService,
      private route: ActivatedRoute,
      private fb: FormBuilder) {
      }

  ngOnInit() {
    this.questionFormGroup = this.fb.group({
      question: ['', Validators.required],
    });

    this.searchOffers();
    // this.getVenues();
  }

  gotoLanding (job) {
    if (job.status !== -4)
    {
      window.open(this.landing + job.id, '_blank');
    }
  }

  // getVenues() {
  //   this.venues = this.venueService.getVenues()
  //   // FIXME: remove duplicates and items without ID (shouldn't be needed)
  //     .map(res => res.filter(item => item.id && item.name));
  // }

  getVenueId($event){
    this.venue_id = $event;
    console.log($event);
  }


  getOfferInput($event){
    this.offer_id = $event;
    console.log($event);
  }

  searchOffers(page?: number, query?: string, venue?: string, active?: boolean, inactive?: boolean, expired?:boolean, deleted?: boolean, archived?:boolean, myOffer?:boolean) {
    this.loading = true;
    this.loading2 = true;
    let status = [];

      if(page == null) {
        page = 1;
      }

      if (active) {
          status.push('1');
      }
      if (inactive) {
        status.push('-1');
        status.push('-2');
      }
      if (expired) {
          status.push('-3');
      }
      if (deleted) {
        status.push('-6');
      }
      if (archived) {
        status.push('-4');
      }

      if (venue){
        console.log(venue);
      }
      console.log(query);
      if(query !== undefined){
        let queryArray = query.split(" - ");
        query = queryArray[0];
      }

      // this.jobs = this.jobService.getOffersFreelancer(query, venue, status, page, this.max, undefined, undefined, undefined, myOffer)
      this.jobs = this.jobService.getReqNoFreelancer('0', '1', '0')
      .do(res => {
          this.page = page;
          this.total = res.pagination.total;
          this.loading = false;
        }
      ).map(res => res.requisitions);

      // this.jobs2 = this.jobService.getOffersFreelancer(query, venue, status, page, this.max, undefined, undefined, undefined, myOffer)
      this.jobs2 = this.jobService.getReqNoFreelancer('0', '1', '1')
      .do(res2 => {
          this.page = page;
          this.total = res2.pagination.total;
          this.loading2 = false;
        }
      ).map(res2 => res2.requisitions);
  }

  openDialogDelete(job,status) {
      let dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
      dialogRef.componentInstance.deleteOffer=true;
      dialogRef.componentInstance.OfferID=job.id;
      dialogRef.componentInstance.OfferStatus=status;
      dialogRef.afterClosed().subscribe(result => {
        if (result != "NO")
          job.status = -6;
      });
  }

  putOffersStatus(job, status) {
    this.jobService.putOffersStatus(job.id, status)
      .subscribe(
        data => console.log('done'),
        error => this.errorMessage = <any>error
      );
  }

  cloneJob(jobId) {
    this._router.navigate(['/createoffer', jobId]);
  }

  viewJob(jobId) {
    this._router.navigate(['/viewoffer', jobId]);
  }

  viewJobKanban(jobId) {
    console.log('/viewjob');
    this._router.navigate(['/viewjob', jobId]);
  }

  //noinspection JSMethodCanBeStatic
  remapJob(job) {
    job.status = 1;
    job.venue = job.venue.country.name;
  }

  openDialogSocialMedia() {
    let dialogRef = this.dialog.open(SocialmediaDialogComponent);
  }

  openDialogPromoteJobsOffer() {
    let dialogRef = this.dialog.open(PromoteJobsOfferDialogComponent);
  }

  openDialogEdit(id) {
    this._router.navigate(['/createoffer', id]);
  }

  openDialogMessage(name) {
    //todo send job
    let dialogRef = this.dialog.open(SendMessageComponent, {data: {
      nameComponent: 'offer',
      nameOffer: name
    }});

    dialogRef.afterClosed().subscribe(result => {
      this.selectedOption = result;
    });
  }

  openDialogInvite(job) {
    if (job.status !== -4)
    {
      let dialogRef = this.dialog.open(InviteComponent);
      dialogRef.componentInstance.createInvite=true;
      dialogRef.componentInstance.Job=job;
      dialogRef.componentInstance.nameComponent='Invitación';
      dialogRef.afterClosed().subscribe(result => {
      if (result != "YES")
        console.log('result:'+result);
      });
    }
  }

  viewIvite(id) {
    this._router.navigate(['/viewinvite/'+id]);
  }
  viewForm() {
    this._router.navigate(['/form']);
  }
  viewVenue() {
    this._router.navigate(['/venue']);
  }

  gotoReport(job) {
    if (job.status !== -4) {
      this._router.navigate(['/reports', job.id]);
    }
  }

  gotoCalendar(job) {
    if (job.status !== -4) {
      this._router.navigate(['/viewevent', job.id]);
    }
  }

  gotoKanban(job) {
    if (job.status !== -4) {
      this._router.navigate(['/viewinvite', job.id]);
    }
  }

  openDialogPaymentCredits() {
    let dialogRef = this.dialog.open(PaymentDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      this.searchOffers();
    });
  }

  openDialogEditOfferVacancy(job) {
    if (job.status !== -4) {
      let dialogRef = this.dialog.open(EditOfferVacancyDialogComponent);
      dialogRef.componentInstance.jobsOffer = job;
      dialogRef.afterClosed().subscribe(result => {
        this.searchOffers();
      });
    }
  }

  openDialogPostFreelancer(job) {
    console.log('postular a ésta oferta' + job);
    this.jobService.postOffersAddFreelancer(job.id)
    .subscribe(
      data => {
        this.dialog.open(MessageBoxDialog, {data: {message: 'Te has postulado a la oferta cómo freelancer, desbes esperar por la confirmación para comenzar a trabajarla', information: true, showIcon: true}});
        this.searchOffers();
      },
      error => {
        this.errorMessage = <any>error;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Hubo un error al postularte a la oferta: ' + this.errorMessage, information: true, showIcon: true}});
      }
    );
  }

  openDialogDataFreelancer(job) {
    this.jobService.getOffersFreelancerById(job.id)
    .subscribe(
      data => {
        let dialogRef = this.dialog.open(ViewRequisition, {
          data: {
            job: data,
          }
        });
        dialogRef.afterClosed().subscribe(result => {
            this.searchOffers();
            if (result != "YES") {
              console.log("");
            }
        });
      },
      error => {
        this.errorMessage = <any>error;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Hubo un error al postularte a la oferta: ' + this.errorMessage, information: true, showIcon: true}});
      }
    );
  }

  showInformationFreelancer() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'Puedes postularte a ofertas y trabajar cómo freelancer', information: true, showIcon: true}});
  }

  onPostQuestion(job) {
    console.log(this.question);
    this.jobService.postQuestionJob(job.id, this.question)
    .subscribe(
      data => {
        this.searchOffers();
      },
      error => {
        this.errorMessage = <any>error;
        this.dialog.open(MessageBoxDialog, {data: {message: 'Hubo un error al realizar la pregunta: ' + this.errorMessage, information: true, showIcon: true}});
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/list-requisition/list-requisition.component.ts